import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IHospitalFetchResponse,
  IHospitalSchemeFetchResponse,
  IHospitalState,
} from "../interfaces/IHospital";
import { getAllHospitals, getSchemeCodes } from "../apis/hospitalService";

const initialState: IHospitalState = {
  availableHospitals: [],
  selectedHospital: null,
  loading: false,
  hospitalToSchemeCodesMap: {},
  errors: {
    fetchHospitalSchemeError: null,
  },
  UserDetails: null,
};

export const getAvailableHospitals = createAsyncThunk(
  "hospital/getAvailableHospitals",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllHospitals();
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchHospitalSchemeCodes = createAsyncThunk(
  "hospital/fetchHospitalSchemeCodes",
  async ({
    hospitalId,
    schemeName,
  }: {
    hospitalId: number;
    schemeName: string;
  }) => {
    const response = await getSchemeCodes(hospitalId, schemeName);
    return response;
  }
);

const hospitalSlice = createSlice({
  name: "hospital",
  initialState: initialState,
  reducers: {
    updateSelectedHospital: (state, action: PayloadAction<number>) => {
      state.availableHospitals?.forEach((hospital) => {
        if (hospital.value === action.payload) {
          state.selectedHospital = hospital;
          localStorage.setItem(
            "edgeProAccessToken",
            JSON.stringify(
              state.UserDetails?.authData?.access_token ||
                JSON.parse(localStorage.getItem("edgeProAccessToken") || "null")
            )
          );
          localStorage.setItem(
            "edgeProRefreshToken",
            JSON.stringify(
              state.UserDetails?.authData?.refresh_token ||
                JSON.parse(
                  localStorage.getItem("edgeProRefreshToken") || "null"
                )
            )
          );
        }
      });
    },
    loginDetails: (state, action: PayloadAction<any>) => {
      state.UserDetails = action.payload;
    },
    resetHospitalToSchemeCodesMap: (state) => {
      state.hospitalToSchemeCodesMap = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAvailableHospitals.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAvailableHospitals.fulfilled, (state, action) => {
        state.loading = false;
        const availableHospitals = action.payload.hospitalsData?.map(
          (data: IHospitalFetchResponse) => {
            return {
              value: data.healthCare.id,
              label: data.healthCare.name,
              requiredDocs: data.healthCareRequiredDocuments,
            };
          }
        );
        state.availableHospitals = [{value: -1, label:"ALL"}, ...availableHospitals];
      })
      .addCase(getAvailableHospitals.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchHospitalSchemeCodes.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchHospitalSchemeCodes.fulfilled, (state, action: any) => {
        state.loading = false;
        if (
          state.selectedHospital &&
          state.selectedHospital.value &&
          action.payload.response
        ) {
          state.hospitalToSchemeCodesMap[action.meta.arg.schemeName] =
            action.payload.response.schemes;
        } else {
          state.errors.fetchHospitalSchemeError =
            "Can't fetch hospital schemes";
        }
      })
      .addCase(fetchHospitalSchemeCodes.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { updateSelectedHospital, loginDetails ,resetHospitalToSchemeCodesMap} = hospitalSlice.actions;
export default hospitalSlice.reducer;
